import { ArrowUpTrayIcon, TrashIcon } from "@heroicons/react/24/outline";
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure, Select, SelectItem} from "@nextui-org/react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { yupResolver } from "@hookform/resolvers/yup";

import ControlledDropZone from "../../../elements/ControlledDropZone";
import { postMultipartFetcher } from "../../../../services/api";
import { isResponseErrorObject } from "../../../../services/helpers";

export default function FormAddSK({ id, mutate }) {
    const {isOpen, onOpen, onOpenChange, onClose} = useDisclosure();
    const { register, control, handleSubmit, setValue, reset, formState: { errors, isSubmitting } } = useForm();

    function onCloseModal() {
        reset({
            documentType: '',   
            photos: [],   
        });
        onClose()
    }
    
    async function onSubmitForm(formData) {
        try {
            const formDataToSend = new FormData();
            formData.documents.forEach((file) => {
                formDataToSend.append(`documents`, file);
            });

            await postMultipartFetcher(`/api/rekom/permohonan/upload-sk/${id}`, formDataToSend)
            mutate()
            toast.success('Upload file SK berhasil!')
        } catch (error) {
            isResponseErrorObject(error?.response?.data?.message)
                ? Object.entries(error.response.data.message).forEach(([key, value]) => {
                    toast.error(value);
                })
                : toast.error(error?.response?.data?.message)
        }
        onCloseModal()
    };

    return (
        <div>
            <Button size='sm' onPress={onOpen} color='primary' startContent={<ArrowUpTrayIcon className='size-4'/>}>Upload File SK</Button>
            <Modal scrollBehavior="inside" onClose={onCloseModal} isDismissable={false} isKeyboardDismissDisabled={false} isOpen={isOpen} onOpenChange={onOpenChange} size="xl">
                <ModalContent>
                {(onClose) => (
                    <>
                        <ModalHeader className="flex flex-col gap-1">Tambah File SK</ModalHeader>
                        <ModalBody>
                            <form onSubmit={handleSubmit(onSubmitForm)}>
                                <div className="flex flex-col gap-3">
                                    <ControlledDropZone
                                        name="documents"
                                        label="File SK"
                                        control={control}
                                        setValue={setValue}
                                        placeholder="Tarik Atau Klik Untuk Upload File SK"
                                        acceptedFile="pdf"
                                    />
                                </div>
                                <div className="mt-6 flex gap-1">
                                    <Button isDisabled={isSubmitting} isLoading={isSubmitting} color="primary" type="submit">
                                        Simpan
                                    </Button>
                                    <Button color="danger" variant="light" onPress={onClose}>
                                        Batal
                                    </Button>
                                </div>
                            </form>
                        </ModalBody>
                        <ModalFooter>
                            
                        </ModalFooter>
                    </>
                )}
                </ModalContent>
            </Modal>
        </div>
    );
}